export function randomId (branding, evt) {
  let text = ''
  let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

//const WAITING_ROOM_ENABLED = parseInt("000001", 2); // 1
//const WAITING_MODERATOR_ADMIT = parseInt("000010", 2); // 2
//const WAITING_COMUNITY_MEMBER_BYPASS = parseInt("000100", 2); // 4
export function getWaitingOptions(value, mask) {
  value = parseInt(value)
  if (value == -1) // the options is not set in the Meeting
    return false
  //System.out.println(" ((OPTIONS)) Check " + Integer.toBinaryString(value) + " & " +  Integer.toBinaryString(mask) + " == " + Integer.toBinaryString(value & mask));
  return ((~value & ~mask) == ~mask)
}

// PRIVATECHAT_NO 				= Integer.parseInt("000001", 2);  // 1
// PRIVATECHAT_READ_ONLY 		= Integer.parseInt("000010", 2);  // 2
// PRIVATECHAT_MODERATOR_ONLY 	= Integer.parseInt("000100", 2);  // 4
// PUBLICCHAT_NO 				= Integer.parseInt("001000", 2);  // 8
// PUBLICCHAT_READ_ONLY 			= Integer.parseInt("010000", 2);  // 16
// PUBLICCHAT_MODERATOR_ONLY 	= Integer.parseInt("100000", 2);  // 32
export function getChatOptions(value, mask) {
  value = parseInt(value)
  if (value == -1) // the options is not set in the Meeting
    return false
  return ((~value & ~mask) == ~mask)
}

export function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}



// WEBPACK FOOTER //
// ./src/functions/globalMethods.js